(function () {
  "use strict";

  var STORAGE_KEY = "opticles:compare:v1";

  function readStoredProducts() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function initComparison() {
    var root = document.querySelector("[data-global-compare]");
    if (!root || root.dataset.initialized === "true") return;
    root.dataset.initialized = "true";

    var maxProducts = Number(root.dataset.maxProducts || 3);
    var tray = root.querySelector("[data-compare-tray]");
    var dialog = root.querySelector("[data-compare-dialog]");
    var count = root.querySelector("[data-compare-count]");
    var thumbs = root.querySelector("[data-compare-thumbs]");
    var openButton = root.querySelector("[data-compare-open]");
    var clearButton = root.querySelector("[data-compare-clear]");
    var status = root.querySelector("[data-compare-status]");
    var tableHost = root.querySelector("[data-compare-table]");
    var closeButton = root.querySelector("[data-compare-close]");
    if (!tray || !dialog || !tableHost) return;

    var selected = new Map();
    readStoredProducts().slice(0, maxProducts).forEach(function (product) {
      if (product && product.id) selected.set(String(product.id), product);
    });

    function productFromButton(button) {
      var card = button.closest("[data-compare-product]");
      var json = card && card.querySelector("[data-compare-product-json]");
      if (!json) return null;

      try {
        return JSON.parse(json.textContent);
      } catch (error) {
        return null;
      }
    }

    function persist() {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(selected.values())));
      } catch (error) {
        /* Comparison still works for the current page when storage is unavailable. */
      }
    }

    function announce(message) {
      if (!status) return;
      status.textContent = "";
      window.setTimeout(function () {
        status.textContent = message;
      }, 20);
    }

    function syncButtons(scope) {
      (scope || document).querySelectorAll("[data-sale-compare-toggle]").forEach(function (button) {
        var product = productFromButton(button);
        var isSelected = product && selected.has(String(product.id));
        button.setAttribute("aria-pressed", isSelected ? "true" : "false");
        var symbol = button.querySelector("span");
        if (symbol) symbol.textContent = isSelected ? "✓" : "+";
      });
    }

    function createCell(tag, text) {
      var cell = document.createElement(tag);
      if (text) cell.textContent = text;
      return cell;
    }

    function addRow(body, label, key, formatter) {
      var products = Array.from(selected.values());
      var values = products.map(function (product) {
        return formatter ? formatter(product) : product[key];
      });
      var hasValue = values.some(function (value) {
        return value !== null && value !== undefined && String(value).trim() !== "";
      });
      if (!hasValue) return;

      var row = document.createElement("tr");
      row.appendChild(createCell("th", label));
      values.forEach(function (value) {
        row.appendChild(createCell("td", value || "—"));
      });
      body.appendChild(row);
    }

    function renderTable() {
      tableHost.textContent = "";
      var products = Array.from(selected.values());
      var table = document.createElement("table");
      table.className = "sale-compare-table";
      var head = document.createElement("thead");
      var headRow = document.createElement("tr");
      headRow.appendChild(createCell("th", "Model"));

      products.forEach(function (product) {
        var cell = document.createElement("th");
        var wrap = document.createElement("div");
        wrap.className = "sale-compare-table__product";

        if (product.image) {
          var image = document.createElement("img");
          image.src = product.image;
          image.alt = product.title || "";
          image.loading = "lazy";
          wrap.appendChild(image);
        }

        var vendor = document.createElement("small");
        vendor.textContent = product.vendor || "";
        wrap.appendChild(vendor);

        var link = document.createElement("a");
        link.href = product.url;
        link.textContent = product.title || "";
        wrap.appendChild(link);

        var remove = document.createElement("button");
        remove.type = "button";
        remove.className = "sale-compare-table__remove";
        remove.dataset.compareRemove = String(product.id);
        remove.setAttribute("aria-label", "Elimină " + product.title + " din comparație");
        remove.textContent = "×";
        wrap.appendChild(remove);

        cell.appendChild(wrap);
        headRow.appendChild(cell);
      });

      head.appendChild(headRow);
      table.appendChild(head);

      var body = document.createElement("tbody");
      addRow(body, "Preț curent", "price");
      addRow(body, "Preț anterior", "previousPrice");
      addRow(body, "Reducere", "discount");
      addRow(body, "Economisești", "saving");
      addRow(body, "Preț cu reducerea de bun venit", "cardPrice");
      addRow(body, "Categorie", "category");
      addRow(body, "Pentru", "audience");
      addRow(body, "Dimensiuni", null, function (product) {
        var values = [product.lensWidth, product.bridgeWidth, product.templeLength].filter(Boolean);
        return values.length === 3 ? values.join("–") : "";
      });
      addRow(body, "Lățime lentilă", "lensWidth", function (product) {
        return product.lensWidth ? product.lensWidth + " mm" : "";
      });
      addRow(body, "Punte nazală", "bridgeWidth", function (product) {
        return product.bridgeWidth ? product.bridgeWidth + " mm" : "";
      });
      addRow(body, "Lungime brațe", "templeLength", function (product) {
        return product.templeLength ? product.templeLength + " mm" : "";
      });
      addRow(body, "Mărime ramă", "frameSize");
      addRow(body, "Formă ramă", "frameShape");
      addRow(body, "Tip ramă", "frameType");
      addRow(body, "Material", "frameMaterial");
      addRow(body, "Culoare", "frameColor");
      addRow(body, "Cod produs", "sku");
      table.appendChild(body);
      tableHost.appendChild(table);
    }

    function renderTray() {
      var products = Array.from(selected.values());
      tray.hidden = products.length === 0;
      if (count) count.textContent = products.length + " / " + maxProducts;
      if (openButton) openButton.disabled = products.length < 2;

      if (thumbs) {
        thumbs.textContent = "";
        products.forEach(function (product) {
          if (!product.image) return;
          var image = document.createElement("img");
          image.src = product.image;
          image.alt = "";
          image.loading = "lazy";
          thumbs.appendChild(image);
        });
      }

      syncButtons(document);
      if (dialog.open) renderTable();
    }

    document.addEventListener("click", function (event) {
      var toggle = event.target.closest("[data-sale-compare-toggle]");
      if (toggle) {
        var product = productFromButton(toggle);
        if (!product) return;
        var key = String(product.id);

        if (selected.has(key)) {
          selected.delete(key);
          announce(product.title + " a fost eliminat din comparație.");
        } else if (selected.size >= maxProducts) {
          announce("Poți compara maximum " + maxProducts + " produse.");
          return;
        } else {
          selected.set(key, product);
          announce(product.title + " a fost adăugat la comparație.");
        }

        persist();
        renderTray();
        return;
      }

      var remove = event.target.closest("[data-compare-remove]");
      if (remove) {
        selected.delete(remove.dataset.compareRemove);
        persist();
        renderTray();
        if (selected.size < 2 && dialog.open) dialog.close();
      }
    });

    clearButton.addEventListener("click", function () {
      selected.clear();
      persist();
      renderTray();
      announce("Comparația a fost golită.");
    });

    openButton.addEventListener("click", function () {
      if (selected.size < 2) return;
      renderTable();
      if (typeof dialog.showModal === "function") dialog.showModal();
      else dialog.setAttribute("open", "");
    });

    closeButton.addEventListener("click", function () {
      if (dialog.open) dialog.close();
    });

    dialog.addEventListener("click", function (event) {
      if (event.target === dialog) dialog.close();
    });

    var main = document.getElementById("main-content");
    if (main && "MutationObserver" in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (!(node instanceof Element)) return;
            if (node.matches("[data-sale-compare-toggle]")) syncButtons(node.parentElement || node);
            else if (node.querySelector("[data-sale-compare-toggle]")) syncButtons(node);
          });
        });
      }).observe(main, { childList: true, subtree: true });
    }

    renderTray();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initComparison);
  } else {
    initComparison();
  }

  document.addEventListener("shopify:section:load", initComparison);
})();
